module.exports = __webpack_public_path__ + "img/ysb.a6d690bf.svg";